export default __webpack_public_path__ + "static/media/theme.4584cdc3.svg";